module.exports = __webpack_public_path__ + "static/media/ic_topup_view.aca79fba.png";